import { RecordContextProvider } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { RefundChargebackReportSummary } from 'types/embedded/refundChargebackReport';

import { DatargidFooterStyled } from './RefundChargebackReportSummaryDatagridFooter.styled';
import { RefundChargebackReportSummaryDatagridFooterAmountField } from './RefundChargebackReportSummaryDatagridFooterAmountField';

type Props = {
  data: RefundChargebackReportSummary;
  conversionCurrency: any;
};

export const RefundChargebackReportSummaryDatagridFooter: React.FC<Props> = ({
  data,
  conversionCurrency,
}) => {
  return (
    <RecordContextProvider value={data}>
      <DatargidFooterStyled data={[data]}>
        <></>
        <Typography sx={{ fontWeight: 500, textTransform: 'uppercase' }} variant="body2">
          Итого:
        </Typography>
        <FunctionField
          render={(record: RefundChargebackReportSummary) => (
            <Typography variant="body2">{record?.refundSummaryCount}</Typography>
          )}
          source="refundSummaryCount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="refundSummaryAmount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="refundSummaryCommissionAmount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="refundTotalSummaryAmount"
        />
        <FunctionField
          render={(record: RefundChargebackReportSummary) => (
            <Typography variant="body2">{record?.chargebackSummaryCount}</Typography>
          )}
          source="chargebackSummaryCount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="chargebackSummaryAmount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="chargebackSummaryCommissionAmount"
        />
        <RefundChargebackReportSummaryDatagridFooterAmountField
          conversionCurrency={conversionCurrency}
          source="chargebackTotalSummaryAmount"
        />
      </DatargidFooterStyled>
    </RecordContextProvider>
  );
};
